import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import Lights from 'components/lights/Lights';
import {
  isLbsMeet,
  isKgMeet,
  getMeetUnits
} from 'util/meetHelper';
import {
  toKg,
  toLbs
} from 'util/conversions';
import {
  getDivisionDoc,
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';
import {
  getCurrentMeet,
  getCurrentPlatform,
  getCurrentAttempt,
  getCurrentLifter
} from 'selectors';


class Platform extends Component {

  render() {
    const { meet, currentAttempt, platform, currentLifter } = this.props;
    if(!platform || !meet) {
      return null;
    }

    const lifterName = _.get(currentLifter, 'name', '-------- ------------');
    const teamName = currentLifter ? _.get(currentLifter, 'team', '') : '-----------';
    let liftName =  _.get(currentAttempt, 'liftName', 'Lift');
    if(liftName === 'bench' && meet.federation === 'USSF') {
      liftName = 'press';
    }
    const attemptNumber = _.get(currentAttempt, 'attemptNumber', '0');
    const currentWeight =  _.get(currentAttempt, 'weight', '000');

    let divisionName = '---------------';
    let weightClassName = '---';

    if(currentLifter) {
      const firstLifterDivision = _.get(currentLifter, 'divisions.0', {});
      const divisionDoc = getDivisionDoc(firstLifterDivision.divisionId, meet);
      if(firstLifterDivision.divisionId && divisionDoc) {
        divisionName = _.get(divisionDoc, 'name');
        // don't display weightclass name if there is only one for this division
        const weightClassDoc = getLifterAwardsWeightClassDoc(meet, currentLifter, firstLifterDivision);
        weightClassName = _.size(divisionDoc.weightClasses) > 1 ? _.get(weightClassDoc, 'name') : '';
      }
    }

    return (
      <div className="platform1">
        <div className="platform-name">{platform.name}</div>
        <Lights meet={meet} platformId={_.get(platform, '_id')} style={{height: 50}} />
        <div className="column">
          <div>{lifterName}</div>
          <div>{teamName}</div>
        </div>
        <div className="column">
          <div>
            {_.capitalize(liftName)}-{attemptNumber}: {currentWeight} {getMeetUnits(meet)}
            <span>
              { isLbsMeet(meet) &&
                <span> ({toKg(currentWeight).toFixed(2)} kg)</span>
              }
              { isKgMeet(meet) &&
                <span> ({toLbs(currentWeight).toFixed(2)} lbs)</span>
              }
            </span>
          </div>
          <div className="divisions">
            <div>
              {divisionName} {weightClassName}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    platform: getCurrentPlatform(state, props),
    currentAttempt: getCurrentAttempt(state, props),
    currentLifter: getCurrentLifter(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(Platform));
